import lightbox from 'lightbox2';

const $trigger = $('.js-product-zoom');

const productZoom = {
  initialize() {
    if ($trigger.length) {
      this.createListeners();
    }
  },

  createListeners() {
    lightbox.option({
      albumLabel: $trigger.data('lightbox-label'),
    });
  },
};

export default productZoom;
